/* hale-ui.js — ЗГЕНЕРОВАНИЙ бандл (2026-09-18). НЕ РЕДАГУВАТИ ВРУЧНУ.
   Інлайн-скрипти п'яти снипетів, винесені з HTML, щоб браузер кешував їх один раз
   (у HTML вони важили ~32 KB на кожну сторінку). Порядок = порядок у документі:
   snippets/hale-modals → hale-cart-drawer → hale-mobile → hale-privacy-banner → hale-chat-quiz.
   Кожен блок самодостатній (IIFE або HALE.ready). Джерела лишаються в снипетах у
   {% comment %}-блоках «HALE-UI-SRC»; після правки перезібрати бандл і залити знову. */

/* ===== modals ===== */
window.HALE.ready(function(){
  var H = window.HALE;

  /* ---------- модалка як layer ---------- */
  function layer(id, name){
    var m = document.getElementById(id); if (!m) return null;
    var api = {
      el: m,
      open: function(opts){
        opts = opts || {};
        if (H.layers.isOpen(name)) return;
        m.classList.add('open');
        m.setAttribute('aria-hidden', 'false');
        H.layers.open(name, m, {
          focusEl: opts.focusEl || m.querySelector('.mclose'),
          trap: true,
          onClose: function(reason){
            m.classList.remove('open');
            m.setAttribute('aria-hidden', 'true');
            if (opts.onClose) opts.onClose(reason);
          }
        });
      },
      close: function(reason){ H.layers.close(name, { reason: reason || 'button' }); }
    };
    m.querySelectorAll('[data-mclose]').forEach(function(b){ b.addEventListener('click', function(){ api.close('button'); }); });
    return api;
  }
  var quiz = layer('quizModal', 'quiz'), acct = layer('acctModal', 'acct');

  /* який елемент відкрив квіз — для повідомлення в Telegram і аналітики */
  var lastSource = '';
  var SRC_LABEL = {
    'header':'шапка · Підбір', 'mtab':'мобільне меню · Підбір', 'drawer':'бічне меню · Підбір',
    'search-empty':'пошук · нічого не знайдено', 'pdp-block':'картка товару · «Підходить мені?»',
    'cart-empty':'порожній кошик', 'hero':'головна · плитка підбору', 'acct':'акаунт'
  };

  /* делеговано: capture, щоб старі [data-open-consult] обробники не відкривали контакт-форму */
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var t = e.target.closest('[data-open-quiz],[data-open-consult],[data-pdp-consult]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      lastSource = t.getAttribute('data-quiz-src') || t.getAttribute('data-src') || '';
      if (quiz) {
        /* capture + stopPropagation вище не дає шапці/пошуку самим закритись,
           тож закриваємо батьківські шари тут (B11) */
        ['msearch','menu','cart'].forEach(function(id){ H.layers.close(id, { reason: 'navigate' }); });
        resetQuiz();
        quiz.open({ focusEl: quiz.el.querySelector('[data-q="need"] .qopt'), onClose: function(){ abortResult(); } });
        H.track('quiz_open', { source: lastSource || 'unknown', page: location.pathname });
      }
      return;
    }
    var a = e.target.closest('[data-open-acct]');
    if (a) { e.preventDefault(); if (acct) acct.open(); }
  }, true);

  if (!quiz) return;

  /* ---------- стан квізу ---------- */
  var el = quiz.el;
  var ROOT = (el.getAttribute('data-root') || '/').replace(/\/$/, '');
  var CART_ADD = el.getAttribute('data-cart-add') || '/cart/add';
  var REC = el.getAttribute('data-rec') || 'всі-товари';
  var TG = (el.getAttribute('data-tg') || 'https://t.me/haleherbals').split('?')[0];
  var FORMAT_LABEL = { tea: 'Чай', caps: 'Капсули', any: 'Будь-який' };

  var steps = el.querySelectorAll('.qstep'), bars = el.querySelectorAll('.quiz-steps i');
  var resBox = el.querySelector('[data-qres]');
  var resTitle = el.querySelector('[data-qres-title]');
  var resSub = el.querySelector('[data-qres-sub]');
  var tgBtn = el.querySelector('[data-qtg]');
  var altBtn = el.querySelector('[data-qalt]');
  var formWrap = el.querySelector('[data-qform]');
  var copiedEl = el.querySelector('[data-qcopied]');
  var data = { need: null, handle: '', url: '', count: 0, format: null, products: [] };
  var idx = 0, ctrl = null;

  function abortResult(){ if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; } }

  function show(n){
    idx = n;
    steps.forEach(function(s, k){ s.classList.toggle('on', k === n); });
    bars.forEach(function(b, k){ b.classList.toggle('on', k <= n); });
    if (copiedEl) copiedEl.hidden = true;
    var focusTarget = steps[n].querySelector('.qopt, [data-qres] a, [data-qres] button, .qback');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }
  function resetQuiz(){
    abortResult();
    data = { need: null, handle: '', url: '', count: 0, format: null, products: [] };
    el.querySelectorAll('.qopt.sel').forEach(function(o){ o.classList.remove('sel'); });
    if (resBox) resBox.innerHTML = '';
    if (formWrap) formWrap.hidden = true;
    if (copiedEl) copiedEl.hidden = true;
    var f = el.querySelector('#quizForm');
    if (f) { f.reset(); var b = f.querySelector('[type="submit"]'); if (b) b.disabled = false; }
    var er = el.querySelector('[data-qerr]'); if (er) er.hidden = true;
    var ok = el.querySelector('[data-qok]'); if (ok) ok.hidden = true;
    show(0);
  }

  /* ---------- крок 1: стан ---------- */
  el.querySelector('[data-q="need"]').addEventListener('click', function(e){
    var o = e.target.closest('.qopt'); if (!o) return;
    this.querySelectorAll('.qopt').forEach(function(x){ x.classList.remove('sel'); });
    o.classList.add('sel');
    data.need = o.getAttribute('data-val');
    data.handle = o.getAttribute('data-handle') || '';
    data.url = o.getAttribute('data-url') || '';
    data.count = parseInt(o.getAttribute('data-count'), 10) || 0;
    if (!data.handle) { data.format = 'any'; loadResult(); return; }   /* «Не знаю» → одразу хіти */
    show(1);
  });

  /* ---------- крок 2: формат ---------- */
  el.querySelector('[data-q="format"]').addEventListener('click', function(e){
    var o = e.target.closest('.qopt'); if (!o) return;
    this.querySelectorAll('.qopt').forEach(function(x){ x.classList.remove('sel'); });
    o.classList.add('sel');
    data.format = o.getAttribute('data-val');
    loadResult();
  });

  el.querySelectorAll('[data-qback]').forEach(function(b){
    b.addEventListener('click', function(){
      abortResult();
      if (idx === 2 && !data.handle) { show(0); return; }
      show(Math.max(idx - 1, 0));
    });
  });
  var restart = el.querySelector('[data-qrestart]');
  if (restart) restart.addEventListener('click', resetQuiz);

  /* ---------- крок 3: результат ---------- */
  function matchesFormat(p, fmt){
    if (fmt === 'any') return true;
    var t = String(p.product_type || '').toLowerCase();
    if (fmt === 'tea') return t.indexOf('фіточа') > -1 || t.indexOf('монотрав') > -1 || t.indexOf('збір') > -1;
    if (fmt === 'caps') return t.indexOf('капсул') > -1;
    return true;
  }
  function cents(price){ return Math.round(parseFloat(String(price).replace(',', '.')) * 100) || 0; }
  function imgUrl(p){
    var src = (p.images && p.images[0] && p.images[0].src) || '';
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }
  function cardHTML(p){
    var v = p.variants && p.variants[0];
    var avail = v ? v.available !== false : false;
    var img = imgUrl(p);
    var price = v ? H.formatMoney(cents(v.price)) : '';
    var cmp = (v && v.compare_at_price && cents(v.compare_at_price) > cents(v.price)) ? '<s>' + H.formatMoney(cents(v.compare_at_price)) + '</s>' : '';
    var multi = p.variants && p.variants.length > 1;
    var url = ROOT + '/products/' + encodeURIComponent(p.handle);
    var cta;
    if (!v || !avail) cta = '<span class="hale-btn hale-btn--ghost qres-na">Немає</span>';
    else if (multi) cta = '<a class="hale-btn hale-btn--ghost" href="' + H.esc(url) + '">Обрати</a>';
    else cta = '<form action="' + H.esc(CART_ADD) + '" method="post" data-source="quiz"><input type="hidden" name="id" value="' + H.esc(v.id) + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="hale-btn hale-btn--primary">В кошик</button></form>';
    return '<article class="qres-card">' +
      '<a class="qres-img" href="' + H.esc(url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + H.esc(img) + '" alt="" width="300" height="300" loading="lazy">' : '') + '</a>' +
      '<div class="qres-body">' +
        '<a class="qres-name" href="' + H.esc(url) + '">' + H.esc(p.title) + '</a>' +
        '<div class="qres-price">' + price + cmp + '</div>' +
        cta +
      '</div>' +
    '</article>';
  }
  function telegramText(){
    var L = ['Доброго дня! Хочу підібрати збір 🌿'];
    if (data.need) L.push('• Турбує: ' + data.need);
    if (data.format && data.handle) L.push('• Формат: ' + FORMAT_LABEL[data.format]);
    if (data.products.length) L.push('• Сайт запропонував: ' + data.products.map(function(p){ return p.title; }).join(', '));
    var src = SRC_LABEL[lastSource] || lastSource;
    if (src) L.push('• Звідки: ' + src);
    L.push('#підбір_з_сайту');
    return L.join('\n');
  }
  function refreshTg(){ if (tgBtn) tgBtn.setAttribute('href', TG + '?text=' + encodeURIComponent(telegramText())); }
  function paintError(){
    resBox.innerHTML = '<div class="qres-empty"><p>Не вдалося завантажити, спробуйте ще.</p>' +
      '<button type="button" class="hale-btn hale-btn--ghost" data-qretry>Спробувати ще</button>' +
      '<p class="qres-empty-tg">або напишіть нам у <a href="' + H.esc(TG) + '" target="_blank" rel="noopener">Telegram</a></p></div>';
    var r = resBox.querySelector('[data-qretry]'); if (r) r.addEventListener('click', loadResult);
  }
  function loadResult(){
    abortResult();
    var isHits = !data.handle;
    var handle = isHits ? REC : data.handle;
    var limit = isHits ? 4 : 12;
    show(2);
    resTitle.textContent = isHits ? 'Хіти, з яких починають' : ('Для «' + data.need + '»');
    resSub.textContent = isHits ? 'Найпопулярніше у покупців. Або уточніть у фітотерапевта — це безкоштовно.' :
      (data.format === 'any' ? 'Три найпопулярніші у цьому стані.' : 'Формат: ' + FORMAT_LABEL[data.format] + ' · найпопулярніші у цьому стані.');
    resBox.innerHTML = '<div class="qres-load" role="status">Підбираємо…</div>';
    refreshTg();

    ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var url = ROOT + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit;
    fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function(r){ if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function(d){
        var all = (d.products || []);
        var list = all.filter(function(p){ return matchesFormat(p, data.format || 'any'); });
        var fellBack = false;
        if (!list.length && all.length) { list = all; fellBack = true; }   /* формату немає у стані — показуємо будь-який */
        var top = list.slice(0, isHits ? 4 : 3);
        data.products = top;
        if (!top.length) {
          resBox.innerHTML = '<div class="qres-empty"><p>У цій колекції поки що порожньо.</p>' +
            '<a class="hale-btn hale-btn--ghost" href="' + H.esc(ROOT + '/collections/all') + '">Дивитись усі товари</a></div>';
          refreshTg();
          return;
        }
        var html = (fellBack ? '<p class="qres-note">У форматі «' + H.esc(FORMAT_LABEL[data.format]) + '» поки немає — ось інші варіанти.</p>' : '') +
          '<div class="qres-grid">' + top.map(cardHTML).join('') + '</div>';
        if (!isHits) {
          var n = (data.format === 'any' || fellBack) ? (data.count || all.length) : list.length;
          var nLabel = (data.format !== 'any' && !fellBack && all.length >= limit) ? (n + '+') : String(n);
          html += '<a class="qres-all" href="' + H.esc(data.url) + '">Дивитись усі ' + nLabel + ' у «' + H.esc(data.need) + '» →</a>';
        } else {
          html += '<a class="qres-all" href="' + H.esc(ROOT + '/collections/all') + '">Дивитись увесь каталог →</a>';
        }
        resBox.innerHTML = html;
        refreshTg();
        var first = resBox.querySelector('a, button'); if (first) first.focus({ preventScroll: true });
        H.track('quiz_result', { need: data.need, format: data.format, source: lastSource, count: top.length, fallback: fellBack });
      })
      .catch(function(err){
        if (err && err.name === 'AbortError') return;
        paintError();
      });
  }

  /* «В кошик» у результаті — submit обробляє ядро; тут лише аналітика і закриття шару */
  resBox.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var id = (f.querySelector('[name="id"]') || {}).value;
    H.track('quiz_result_atc', { need: data.need, format: data.format, variant: id, source: lastSource });
    setTimeout(function(){ quiz.close('atc'); }, 50);
  });
  resBox.addEventListener('click', function(e){
    var a = e.target.closest('a.qres-all, a.qres-name, a.qres-img, a.hale-btn');
    if (a) { H.track('quiz_result_link', { need: data.need, href: a.getAttribute('href') }); quiz.close('navigate'); }
  });

  /* ---------- Telegram: копіюємо текст у момент кліку ---------- */
  if (tgBtn) tgBtn.addEventListener('click', function(){
    H.copyText(telegramText());
    if (copiedEl) copiedEl.hidden = false;
    H.track('chat_open', { source: 'quiz-telegram', need: data.need, format: data.format, from: lastSource || '', page: location.pathname });
  });

  /* ---------- фолбек: телефон ---------- */
  if (altBtn) altBtn.addEventListener('click', function(){
    if (!formWrap) return;
    formWrap.hidden = !formWrap.hidden;
    if (!formWrap.hidden) { var i = formWrap.querySelector('input:not([type="hidden"])'); if (i) i.focus(); }
  });
  var form = el.querySelector('#quizForm');
  if (form) form.addEventListener('submit', function(e){
    e.preventDefault(); e.stopPropagation();
    var pEl = form.querySelector('[name="contact[phone]"]');
    var phone = ((pEl && pEl.value) || '').trim();
    var bodyEl = form.querySelector('[data-qbody]');
    if (bodyEl) bodyEl.value = telegramText() + '\nТелефон: ' + phone;
    var err = el.querySelector('[data-qerr]'), ok = el.querySelector('[data-qok]');
    if (err) err.hidden = true; if (ok) ok.hidden = true;
    var btn = form.querySelector('[type="submit"]'), btnTxt = '';
    if (btn) { btnTxt = btn.innerHTML; btn.disabled = true; btn.textContent = 'Надсилаємо…'; }
    var action = (form.getAttribute('action') || '/contact').split('#')[0];
    fetch(action, { method: 'POST', headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }, body: new URLSearchParams(new FormData(form)) })
      .then(function(r){
        if (!r.ok) throw new Error('http ' + r.status);
        if (btn) { btn.disabled = false; btn.innerHTML = btnTxt; }
        form.reset(); if (ok) ok.hidden = false;
        H.track('lead_form', { source: 'quiz-phone', from: lastSource || '', page: location.pathname });
      })
      .catch(function(){ if (btn) { btn.disabled = false; btn.innerHTML = btnTxt; } if (err) err.hidden = false; });
  });

  /* ---------- акаунт: вкладки ---------- */
  if (acct) {
    acct.el.querySelectorAll('.acct-tabs button').forEach(function(t){
      t.addEventListener('click', function(){
        acct.el.querySelectorAll('.acct-tabs button').forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        var tab = t.getAttribute('data-tab');
        acct.el.querySelectorAll('[data-tabpane]').forEach(function(p){ p.hidden = p.getAttribute('data-tabpane') !== tab; });
      });
    });
  }
});

/* ===== cart-drawer ===== */
window.HALE.ready(function(){
  var H = window.HALE;
  var drawer = document.querySelector('.hale [data-cart-drawer]');
  var overlay = document.querySelector('.hale [data-cd-overlay]');
  if(!drawer || !overlay) return;
  var $ = function(s){ return drawer.querySelector(s); };
  var itemsEl = $('[data-cd-items]'), totalEl = $('[data-cd-total]'), bar = $('[data-cd-bar]'),
      shipMsg = $('[data-cd-ship-msg]'), recWrap = $('[data-cd-rec]'), recList = $('[data-cd-rec-list]'),
      bodyEl = $('[data-cd-body]'), emptyEl = $('[data-cd-empty]'), footEl = $('[data-cd-foot]'), shipEl = $('[data-cd-ship]');
  var money = H.formatMoney, esc = H.esc;

  /* ---- opening policy (2026-09-11, рішення власника) ----
     Перше додавання в сесії відкриває шухляду — один раз. Кожне наступне
     додавання шухляду НЕ відкриває: показується тост, а верхня смужка
     «… до безкоштовної доставки · Оформити» (hale-cart-remind.js) з'являється
     сама з другого додавання. Прапорець — sessionStorage, тож у новій вкладці
     чи після закриття браузера шухляда знову відкриється на першому додаванні. */
  var AUTO = 'hale_drawer_auto';
  function autoShown(){ try{ return sessionStorage.getItem(AUTO) === '1'; }catch(e){ return false; } }
  function markAutoShown(){ try{ sessionStorage.setItem(AUTO, '1'); }catch(e){} }

  function open(){
    if(H.layers.isOpen('cart')) return;
    overlay.classList.add('show'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    recsFor(H.cart.get()); /* Фаза B: рекомендації вантажаться при відкритті, а не на кожній сторінці */
    H.layers.open('cart', drawer, {
      focusEl: drawer.querySelector('[data-cd-close]'),
      onClose: function(reason){
        overlay.classList.remove('show'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
      }
    });
  }
  function close(reason){ H.layers.close('cart', { reason: reason || 'user' }); }
  drawer.querySelectorAll('[data-cd-close]').forEach(function(b){ b.addEventListener('click', function(){ close('user'); }); });
  overlay.addEventListener('click', function(){ close('user'); });
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('.hale a.cart');
    if(a){ e.preventDefault(); open(); }
  });

  /* ---- rendering ---- */
  function renderShip(total){
    var F = H.freeShip;
    if(total >= F){ shipMsg.innerHTML = '<span class="done">Ви отримали безкоштовну доставку 🌿</span>'; bar.style.width = '100%'; }
    else { shipMsg.innerHTML = 'Замов ще на <b>' + money(F - total) + '</b> та отримай <span class="done">безкоштовну доставку</span>'; bar.style.width = Math.min(100, total / F * 100) + '%'; }
  }
  function itemHTML(it){
    var img = it.image ? ('<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2')) + '" alt="">') : '';
    var meta = (it.variant_title && it.variant_title !== 'Default Title') ? ('<div class="cdi-meta">' + esc(it.variant_title) + '</div>') : '';
    return '<div class="cd-item" data-key="' + esc(it.key) + '">'
      + '<a class="cdi-img" href="' + esc(it.url) + '">' + img + '</a>'
      + '<div><a class="cdi-name" href="' + esc(it.url) + '" style="color:inherit">' + esc(it.product_title) + '</a>' + meta
      + '<div class="cdi-qty"><button type="button" data-cd-dec aria-label="Менше">−</button><span>' + it.quantity + '</span><button type="button" data-cd-inc aria-label="Більше">+</button></div></div>'
      + '<div class="cdi-right"><button type="button" class="cdi-rm" data-cd-rm aria-label="Видалити"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 7h14M9 7V5h6v2M7 7l1 13h8l1-13"/></svg></button><span class="cdi-price">' + money(it.final_line_price) + '</span></div>'
      + '</div>';
  }
  function render(cart){
    if(!cart) return;
    if(cart.item_count === 0){ bodyEl.hidden = true; footEl.hidden = true; shipEl.hidden = true; emptyEl.hidden = false; return; }
    bodyEl.hidden = false; footEl.hidden = false; shipEl.hidden = false; emptyEl.hidden = true;
    itemsEl.innerHTML = cart.items.map(itemHTML).join('');
    totalEl.textContent = money(cart.items_subtotal_price);
    renderShip(cart.items_subtotal_price);
    if(H.layers.isOpen('cart')) recsFor(cart);
  }
  function recsFor(cart){
    if(!cart || !cart.items || !cart.items[0]) return;
    loadRecs(cart.items[0].product_id, cart.items.map(function(i){ return i.product_id; }));
  }
  /* quantity buttons: read the CURRENT quantity from the store, mark the row busy
     until the store answers — no stale q, no double-tap races */
  itemsEl.addEventListener('click', function(e){
    var b = e.target.closest('[data-cd-inc],[data-cd-dec],[data-cd-rm]'); if(!b) return;
    var row = b.closest('.cd-item'); if(!row || row.classList.contains('is-busy')) return;
    var key = row.getAttribute('data-key');
    var it = (H.cart.get().items || []).filter(function(x){ return x.key === key; })[0];
    if(!it) return;
    var q = b.hasAttribute('data-cd-rm') ? 0 : (b.hasAttribute('data-cd-inc') ? it.quantity + 1 : it.quantity - 1);
    row.classList.add('is-busy');
    H.cart.change(key, q).catch(function(err){ row.classList.remove('is-busy'); H.ui.toast((err && err.message) || 'Не вдалося оновити кошик', { kind: 'error' }); });
  });

  var recFor = null;
  function loadRecs(pid, inCart){
    if(recFor === pid){ return; }
    recFor = pid;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); }).then(function(d){
        var prods = (d.products || []).filter(function(p){ return inCart.indexOf(p.id) === -1; }).slice(0, 4);
        if(!prods.length){ recWrap.hidden = true; return; }
        recWrap.hidden = false;
        recList.innerHTML = prods.map(function(p){
          var v = p.variants && p.variants[0]; if(!v) return '';
          var img = p.featured_image ? ('<img src="' + esc(p.featured_image) + '" alt="">') : '';
          var badge = ''; if(v.compare_at_price && v.compare_at_price > v.price){ badge = '<span class="cdr-badge">-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>'; }
          var price = '<span class="cdr-price">' + money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</span>';
          return '<div class="cd-rc">' + badge + '<a class="cdr-img" href="' + esc(p.url) + '">' + img + '</a><div><a class="cdr-name" href="' + esc(p.url) + '" style="color:inherit">' + esc(p.title) + '</a><div class="cdr-row">' + price + '<button type="button" class="cdr-add" data-rec-add="' + v.id + '">Додати</button></div></div></div>';
        }).join('');
      }).catch(function(){ recWrap.hidden = true; });
  }

  drawer.addEventListener('click', function(e){
    var b = e.target.closest('[data-rec-add]'); if(!b) return;
    e.preventDefault();
    var t = b.textContent; b.textContent = '…'; b.disabled = true;
    H.cart.add({ id: b.getAttribute('data-rec-add'), quantity: 1 }, { source: 'drawer-rec' })
      .catch(function(err){ H.ui.toast((err && err.message) || 'Не вдалося додати', { kind: 'error' }); })
      .then(function(){ b.textContent = t; b.disabled = false; });
  });

  /* ---- store subscription ---- */
  H.on('hale:cart', function(e){
    var d = e.detail;
    render(d.cart);
    if(d.reason !== 'add') return;
    if(H.layers.isOpen('cart')) return;
    if(!autoShown()){ markAutoShown(); open(); }
    else { H.ui.toast('Додано в кошик', { action: 'Переглянути кошик →', onAction: open }); }
  });
  render(H.cart.get());
});

/* ===== mobile ===== */
window.HALE.ready(function(){
  var H = window.HALE;
  var ov = document.querySelector('[data-msearch]');
  var openers = document.querySelectorAll('[data-msearch-open]');

  if (ov) {
    var input = ov.querySelector('[data-msearch-input]');
    function openS(e){
      var src = 'mtab';
      if (e && e.currentTarget && e.currentTarget.getAttribute('data-msearch-src')) {
        src = e.currentTarget.getAttribute('data-msearch-src');
      }
      if (H.layers.isOpen('msearch')) return;
      ov.classList.add('open');
      ov.setAttribute('aria-hidden', 'false');
      openers.forEach(function(b){ b.setAttribute('aria-expanded', 'true'); });
      H.layers.open('msearch', ov, {
        focusEl: input,
        trap: true,
        onClose: function(){
          ov.classList.remove('open');
          ov.setAttribute('aria-hidden', 'true');
          openers.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
        }
      });
      /* панель порожнього стану малює hale-desktop-search.js по фокусу */
      if (input) input.dispatchEvent(new Event('focus'));
      H.track('search_open', { source: src, page: location.pathname });
    }
    function closeS(){ H.layers.close('msearch', { reason: 'button' }); }
    openers.forEach(function(b){ b.addEventListener('click', openS); });
    ov.querySelectorAll('[data-msearch-close]').forEach(function(b){ b.addEventListener('click', closeS); });
    /* клік по результату / чіпу / «Підібрати» — закриваємо оверлей */
    ov.addEventListener('click', function(e){
      if (e.target.closest('a[href]') || e.target.closest('[data-open-quiz]')) closeS();
    });
  }

  /* бейдж кошика [data-mcart-count] малює лише assets/hale-cart-count.js (Фаза B) */
});

/* ===== privacy ===== */
(function(){
  /* Shopify default (en) → Ukrainian. Exact-match only: customised admin copy is left alone. */
  var T = {
    "We value your privacy": "Ми цінуємо вашу приватність",
    "We use cookies and other technologies to personalize your experience, perform marketing, and collect analytics. Learn more in our": "Ми використовуємо cookie, щоб сайт працював коректно, а також для аналітики та маркетингу. Детальніше — у",
    "Privacy Policy.": "Політиці конфіденційності.",
    "Manage preferences": "Налаштувати",
    "Accept": "Прийняти",
    "Decline": "Відхилити",
    "Cookie preferences": "Налаштування cookie",
    "Accept all": "Прийняти всі",
    "Decline all": "Відхилити всі",
    "Save my choices": "Зберегти вибір",
    "You control your data": "Ви керуєте своїми даними",
    "Learn more about the cookies we use, and choose which cookies to allow.": "Дізнайтеся, які cookie ми використовуємо, і оберіть, які з них дозволити.",
    "Required": "Обов'язкові",
    "These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.": "Потрібні для роботи сайту: вхід в акаунт, додавання товарів у кошик.",
    "Personalization": "Персоналізація",
    "These cookies store details about your actions to personalize your next visit to the website.": "Зберігають ваші дії, щоб персоналізувати наступний візит.",
    "Marketing": "Маркетинг",
    "These cookies are used to optimize marketing communications and show you ads on other sites.": "Використовуються для маркетингових комунікацій і реклами на інших сайтах.",
    "Analytics": "Аналітика",
    "These cookies help us understand how you interact with the site. We use this data to identify areas to improve.": "Допомагають зрозуміти, як ви користуєтесь сайтом, щоб ми могли його покращувати."
  };
  var A = { "Close dialog": "Закрити" };

  function localize(root){
    if(!root || root.getAttribute('data-hale-l10n')) return;
    root.setAttribute('data-hale-l10n', '1');
    var it = document.createNodeIterator(root, NodeFilter.SHOW_TEXT), n;
    while((n = it.nextNode())){
      var s = n.textContent, k = s.trim();
      if(!k || !T.hasOwnProperty(k)) continue;
      n.textContent = s.replace(k, T[k]);
    }
    var els = root.querySelectorAll('[aria-label]');
    for(var i = 0; i < els.length; i++){
      var l = els[i].getAttribute('aria-label');
      if(A.hasOwnProperty(l)) els[i].setAttribute('aria-label', A[l]);
    }
    var link = root.querySelector('#shopify-pc__banner__body-policy-link');
    if(link) link.setAttribute('href', '/policies/privacy-policy');
  }

  function scan(){
    localize(document.getElementById('shopify-pc__banner'));
    localize(document.getElementById('shopify-pc__prefs'));
  }

  if(document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  if('MutationObserver' in window){
    new MutationObserver(function(muts){
      for(var i = 0; i < muts.length; i++){
        var added = muts[i].addedNodes;
        for(var j = 0; j < added.length; j++){
          var a = added[j];
          if(a.nodeType !== 1) continue;
          if(a.id === 'shopify-pc__banner' || a.id === 'shopify-pc__prefs' ||
             (a.querySelector && a.querySelector('#shopify-pc__banner, #shopify-pc__prefs'))){ scan(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ===== chat-quiz ===== */
window.HALE.ready(function(){
  var CHAT_URL='https://t.me/haleherbals';
  var DELAY=3000, TEASER_LIFE_MOBILE=30000, KEY='hale_hcq_seen';
  var root=document.querySelector('.hale [data-hcq]');
  var wrap=document.querySelector('.hale [data-hcq-open]');
  var launch=wrap && wrap.querySelector('.hcq-launch');
  var teaser=wrap && wrap.querySelector('[data-hcq-teaser]');
  var teaserX=wrap && wrap.querySelector('[data-hcq-teaser-x]');
  var ping=wrap && wrap.querySelector('[data-hcq-ping]');
  var peek=document.querySelector('.hale [data-hcq-peek]');
  var peekGo=peek && peek.querySelector('[data-hcq-peek-go]');
  var peekBubble=peek && peek.querySelector('.hcq-peek-bubble');
  var peekX=peek && peek.querySelector('[data-hcq-peek-x]');
  if(!root||!wrap) return;

  window.haleTrack = window.haleTrack || function(name, params){
    params = params || {};
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({event:name}, params)); }catch(e){}
    try{ if(typeof window.gtag === 'function') window.gtag('event', name, params); }catch(e){}
    try{ if(typeof window.fbq === 'function') window.fbq('trackCustom', name, params); }catch(e){}
  };

  /* Same helper as snippets/hale-modals.liquid — redeclared defensively so this
     widget does not depend on which snippet the header renders first.
     execCommand runs FIRST on purpose: navigator.clipboard.writeText rejects
     ASYNCHRONOUSLY, so by the time a rejection arrives the click gesture has
     expired and no fallback can still run. Measured in this theme: writeText was
     called with the right text and rejected with NotAllowedError, while
     execCommand inside the same click returned true. The contentEditable + Range
     dance is what makes the textarea copy work on iOS Safari. */
  window.haleCopyText = window.haleCopyText || function(text){
    var ok = false;
    try{
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.contentEditable = 'true';
      ta.readOnly = false;
      ta.setAttribute('aria-hidden','true');
      ta.style.cssText = 'position:fixed; top:0; left:-9999px; opacity:0';
      document.body.appendChild(ta);
      var range = document.createRange();
      range.selectNodeContents(ta);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      ta.setSelectionRange(0, 999999);
      ok = document.execCommand('copy');
      sel.removeAllRanges();
      ta.remove();
    }catch(e){}
    try{
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(text).catch(function(){});
      }
    }catch(e){}
    return ok;
  };

  function noteCopied(){
    var t=document.querySelector('.hcq-toast');
    if(!t){
      t=document.createElement('div');
      t.className='hcq-toast';
      t.textContent='Повідомлення скопійовано — вставте його в чаті й надішліть';
      document.body.appendChild(t);
    }
    requestAnimationFrame(function(){ t.classList.add('on'); });
    setTimeout(function(){ t.classList.add('on'); }, 60);   /* rAF is paused in background tabs */
    clearTimeout(t._h);
    t._h=setTimeout(function(){ t.classList.remove('on'); }, 3600);
  }

  document.querySelectorAll('[data-hale-chat]').forEach(function(a){ a.setAttribute('href', CHAT_URL); });

  var goBtn=root.querySelector('[data-hcq-go]');

  function msgFor(topic){
    var msg='Доброго дня! Хочу підібрати засіб';
    if(topic) msg+=' — '+topic;
    var t=document.querySelector('.hale .pinfo h1');
    if(t) msg+=' (дивлюсь: '+t.textContent.trim()+')';
    msg+='. Підкажіть, будь ласка.';
    return msg;
  }
  function tgLink(topic){ return CHAT_URL+'?text='+encodeURIComponent(msgFor(topic)); }

  /* copy + hint, then let the caller open Telegram. Must stay synchronous:
     the clipboard write only works inside the click gesture. */
  function handoff(topic){
    window.haleCopyText(msgFor(topic));
    noteCopied();
  }

  goBtn.setAttribute('href', tgLink(''));

  var isMobile = window.matchMedia('(max-width:900px)').matches;

  function hideTeaser(){ if(teaser)teaser.hidden=true; if(ping)ping.hidden=true; }
  function openCard(){ hideTeaser(); root.hidden=false; window.haleTrack('chat_widget_open',{source:'launcher',page:location.pathname}); }
  function closeCard(){ root.hidden=true; }
  function markSeen(){ try{ sessionStorage.setItem(KEY,'1'); }catch(e){} }

  root.querySelector('[data-hcq-close]').addEventListener('click', closeCard);
  launch.addEventListener('click', openCard);
  if(teaser)teaser.addEventListener('click', function(e){ if(e.target===teaserX) return; openCard(); });
  if(teaserX)teaserX.addEventListener('click', function(e){ e.stopPropagation(); hideTeaser(); markSeen(); });

  root.querySelectorAll('[data-hcq-topic]').forEach(function(b){
    b.addEventListener('click', function(){
      var topic=b.getAttribute('data-hcq-topic');
      handoff(topic);
      window.haleTrack('chat_open',{source:'popup-topic', topic:topic, page:location.pathname});
      window.open(tgLink(topic), '_blank', 'noopener');
    });
  });
  goBtn.addEventListener('click', function(){
    handoff('');
    window.haleTrack('chat_open',{source:'popup-cta', page:location.pathname});
  });

  function peekGoFn(){
    handoff('');
    window.haleTrack('chat_open',{source:'mobile-peek', page:location.pathname});
    window.open(tgLink(''), '_blank', 'noopener');
  }
  function hidePeek(){ if(!peek||peek.hidden) return; peek.classList.add('hcq-hide'); setTimeout(function(){ peek.hidden=true; peek.classList.remove('hcq-hide'); }, 460); }
  if(peekGo)peekGo.addEventListener('click', peekGoFn);
  if(peekBubble)peekBubble.addEventListener('click', function(e){ if(e.target===peekX) return; peekGoFn(); });
  if(peekX)peekX.addEventListener('click', function(e){ e.stopPropagation(); hidePeek(); markSeen(); });

  /* hide the peek whenever a drawer / menu / quiz / modal opens (they lock body scroll) */
  function bodyLocked(){
    var b=document.body;
    try{ if(getComputedStyle(b).overflow==='hidden') return true; }catch(e){}
    return /drawer-open|menu-open|modal-open|quiz-open|search-open|nav-open|overflow-hidden|no-scroll/i.test(b.className);
  }
  /* HALE.layers is the only thing that opens drawers/panels/modals and it emits
     hale:layer — a subscription instead of watching <body> for a scroll-lock. */
  var watching=false;
  function watchOverlays(){
    if(watching) return;
    watching=true;
    window.HALE.on('hale:layer', function(e){
      if(e.detail && e.detail.open && peek && !peek.hidden) hidePeek();
      if(e.detail && e.detail.open && teaser && !teaser.hidden) hideTeaser();
      /* картка (z 300) вища за шухляди (201): при відкритті будь-якого шару закриваємо її (B12) */
      if(e.detail && e.detail.open && root && !root.hidden) closeCard();
    });
  }

  /* підписуємось завжди, а не лише в гілці peek на головній — інакше картка
     не закривалась при відкритті шухляди на інших сторінках (аудит B12) */
  watchOverlays();

  var seen; try{ seen=sessionStorage.getItem(KEY); }catch(e){}
  if(!seen){
    setTimeout(function(){
      if(!root.hidden) return;            /* the card is already open */
      if(bodyLocked()) return;            /* a drawer/menu is already open */
      if(teaser)teaser.hidden=false;
      if(ping)ping.hidden=false;
      window.haleTrack('chat_teaser_show',{source:isMobile?'mobile':'desktop', page:location.pathname});
      if(isMobile) setTimeout(hideTeaser, TEASER_LIFE_MOBILE);  /* fold away after 30 s on phones */
    }, DELAY);
  }
});
